import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { Observable } from "rxjs";

@Component({
    selector: 'app-accordion-panel',
    templateUrl: './accordion-panel.component.html',
    styleUrls: ['./accordion-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionPanelComponent {
    @Input() header = '';
    // Null hides the counter, for a panel whose content is not a list.
    @Input() count: number | null = null;
    @Input() disabled = false;
    @Input() selected = false;
    @Input() currentLanguage!: Observable<string>;
    constructor(private cd: ChangeDetectorRef) { }

    /** Used by ReturnFocusDirective to reopen the panel when returning from one of its rows. */
    open(): void {
        this.selected = true;
        this.cd.markForCheck();
    }
}